import { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { getLocations, getUnassignedSummary } from '@/services/locations';

// RC-192: `QueryLocationsDto.limit` aceita no máximo 100; acima disso a API responde 400.
const ACTIVE_LOCATIONS_LIMIT = 100;

export function useActiveLocations(options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: ['locations', 'active'],
    queryFn: async () => (await getLocations({ active: true, limit: ACTIVE_LOCATIONS_LIMIT })).locations,
    enabled: options?.enabled ?? true,
    staleTime: 60 * 1000,
  });
}

/** Story 69.8: quantos agendamentos estão sem unidade e qual é a padrão (banner, cartão, página). */
export function useUnassignedSummary(options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: ['locations', 'unassigned-summary'],
    queryFn: getUnassignedSummary,
    enabled: options?.enabled ?? true,
    staleTime: 60 * 1000,
  });
}

/** Story 69.2: com 2 ou mais unidades ativas a escolha é obrigatória; com 1 o servidor preenche. */
export function useUnitChoice({ enabled, initialId }: { enabled: boolean; initialId?: string }) {
  const { data: units = [], isLoading } = useActiveLocations({ enabled });
  const [chosen, setChosen] = useState(initialId ?? '');

  useEffect(() => {
    if (enabled) setChosen(initialId ?? '');
  }, [enabled, initialId]);

  const required = units.length >= 2;
  const value = units.some((unit) => unit.id === chosen) ? chosen : '';

  return {
    units,
    value,
    setValue: setChosen,
    blocksSubmit: isLoading || (required && !value),
    payloadId: required ? value || undefined : undefined,
  };
}
